import Swal from 'sweetalert2';
import { App, Plugin } from 'vue';

// SweetAlert 옵션 타입 정의
interface SwalOptions {
  confirmButtonColor?: string;
  cancelButtonColor?: string;
  confirmButtonText?: string;
  cancelButtonText?: string;
  customClass?: {
    [key: string]: string;
  };
  [key: string]: any;
}

// 기본 옵션 설정
const swalOptions: SwalOptions = {
  confirmButtonColor: '#384279',
  cancelButtonColor: '#d33',
  confirmButtonText: '확인',
  cancelButtonText: '취소',
  customClass: {
    title: 'sweet_title',
    popup: 'sweet_popup',
    content: 'sweet_content',
    htmlContainer: 'sweet_content',
    container: 'sweet_container',
    confirmButton: 'sweet_okbtn',
    cancelButton: 'sweet_cancelbtn',
    actions: 'sweet_action'
  },
};

// Vue 플러그인 정의
const SweetAlertPlugin: Plugin = {
  install: (app: App) => {
    app.config.globalProperties.$swal = function(arg: string | SwalOptions) {
      if (typeof arg === 'string') {
        return Swal.fire({
          ...swalOptions,
          title: arg  // 문자열을 제목으로 사용
        });
      } else {
        return Swal.fire({
          ...swalOptions,
          ...arg
        });
      }
    };
  }
};

export default SweetAlertPlugin;